import React from 'react'
import { connect } from 'react-redux'
import c from 'classnames'
import sortBy from 'lodash/sortBy'
import isEmpty from 'lodash/isEmpty'
import pluralize from 'pluralize'

import Tag from 'discada/dist/Tag'
import Icon from 'discada/dist/Icon'
import Loading from 'discada/dist/Loading'

import {
  getFilterGroup,
  getFilterGroups,
  isFilterValueSelected,
} from 'selectors/inventorySelectors'

import { removeFromPageState } from 'actions/pageStateActions'
import { toggleFilter, clearFilters } from 'actions/inventoryActions'

import './InventoryFilters.scss'

const FILTER_GROUP_ORDER = [
  'feature',
  'condition',
  'year',
  'make',
  'model',
  'trim',
  'body',
  'fuel-type',
  'passengers',
  'lot',
  'model-number',
]

///////////////////////////////////////////////////////////////////////////

export function FilterPreso(props) {
  let {
    value,
    count = 0,
    total = 0,
    selected,
    className,
    toggleFilter,
    onClick = () => {},
  } = props

  return (
    <span
      className={c('inventory-filter', className, {
        selected,
        'no-results': !count,
      })}
      onClick={() => {
        toggleFilter(props)
        onClick(props)
      }}
    >
      <span className="filter-result-value">
        <Icon prefix="far" icon={selected ? 'check-square' : 'square'} />{' '}
        {value
          .toString()
          .split('-')
          .join(' ')}
      </span>
      {count ? <span className="filter-result-count">{count}</span> : null}
    </span>
  )
}

export function FilterPresoOld(props) {
  let {
    value,
    count = 0,
    selected,
    className,
    toggleFilter,
    onClick = () => {},
  } = props

  return (
    <Tag
      compound
      className={c('inventory-filter', className, {
        selected,
        'no-results': !count,
      })}
      onClick={() => {
        toggleFilter(props)
        onClick(props)
      }}
    >
      <Tag color="primary">
        {value} <span className="filter-result-count">{count}</span>
      </Tag>
      {selected && <Tag color="primary" isDelete />}
    </Tag>
  )
}

export const Filter = connect(
  (state, op) => {
    return {
      ...op,
      selected: isFilterValueSelected(state, op.filter, op.value),
    }
  },
  { toggleFilter },
)(FilterPreso)

///////////////////////////////////////////////////////////////////////////

export class FilterGroupPreso extends React.Component {
  constructor(...args) {
    super(...args)

    this.state = {
      shouldFilter: false,
    }
  }

  render() {
    let { label, filters = [], className } = this.props,
      { shouldFilter } = this.state,
      totalCount = filters.length,
      selectedCount = filters.reduce(
        (ret, f) => (ret += f.selected || f.count > 0 ? 1 : 0),
        0,
      ),
      filterFilters = f => !shouldFilter || f.count || f.selected

    return (
      <div className={c('filter-group', `filter-group-${label}`, className)}>
        <h4>
          {selectedCount} of {totalCount}{' '}
          <strong>{pluralize(label, filters.length)}</strong> match your search
          <small onClick={() => this.setState({ shouldFilter: !shouldFilter })}>
            {shouldFilter
              ? `Show all ${pluralize(label)}`
              : `Show only matching ${pluralize(label)}`}
          </small>
        </h4>
        <div className="inventory-filters-list">
          {sortBy(filters, f => f.value.join())
            .filter(filterFilters)
            .map((f, i) => (
              <Filter key={i} {...f} />
            ))}
        </div>
      </div>
    )
  }
}

export const FilterGroup = connect((_, op) => ({
  ...op,
}))(FilterGroupPreso)

///////////////////////////////////////////////////////////////////////////

export function InventoryFiltersPreso({
  filterGroups,
  className,
  closeFiltersModal,
}) {
  if (isEmpty(filterGroups)) return <Loading size="small" />

  return (
    <div className={c('inventory-filters', className)}>
      {FILTER_GROUP_ORDER.filter(k => !isEmpty(filterGroups[k])).map(k => (
        <FilterGroup
          key={k}
          closeFiltersModal={closeFiltersModal}
          label={k}
          filters={filterGroups[k]}
        />
      ))}
    </div>
  )
}

export const InventoryFilters = connect(
  (state, op) => ({
    ...op,
    filterGroups: op.group
      ? { [op.group]: getFilterGroup(state, op.group, true) }
      : getFilterGroups(state, true),
  }),
  { removeFromPageState, clearFilters },
)(InventoryFiltersPreso)
